import React from 'react';
import { useCommonStyles } from '../../../materialConfig/commonStyles';
import { BaseTypography, BaseCard } from "src/components/common";
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import guideImg from "../../../assets/images/media-profile.jpg";
import { ModernTitle } from '../../../components/common/BaseTypography/ModernTitle';
import { ServiceTable } from './ServiceTable';
import { ExpertFormContainer } from '../../../features/auth/register/regAsExpert1/expertForm/ExpertFormContainer';

import doctorBanner from './doctor-banner.jpg';
import imgNew from '../img-new.png';
import img1 from './img1.png';
import img2 from './img2.jpg';
import img3 from './img3.jpg';
import img4 from './img4.png';
import img5 from './img5.png';
import img7 from './img7.jpg'; 
import icon1 from './icon1.svg';
import icon2 from './icon2.svg';
import icon3 from './icon3.svg';
import email from '../email.svg';
import Facebook from '../Facebook.svg';
import insta from '../insta.svg';
import LinkedIn from '../LinkedIn.svg';
import phone from '../phone.svg';
import twitter from '../twitter.svg';	
import youtube from '../youtube.svg';

const useStyles = makeStyles((theme) => ({
    root: {
       maxWidth: 740,

		[theme.breakpoints.down('sm')]: {
		  padding: '0px 20px',
		},
    },
	videoContainer: {
		textAlign: 'center',  
		margin: '20px auto 20px auto', 
		padding: '0 20px',
	  },
}));

export const Doctorpackage: React.FC = () => {
    const commonClasses = useCommonStyles();
    const classes = useStyles();
    return (
		<div className={commonClasses.pageWrapper} style={{ paddingTop: '0' }} >
		  <Grid container spacing={10} className={clsx(commonClasses.container)}>
			  <Grid item xs={12} className='package-banner'>
				<Grid container spacing={4}>
					<Grid item md={7} xs={12}>
					  <BaseTypography
						  variant='h1'
						  style={{ color: '#0090E5', fontSize: '4vw', lineHeight: '4vw', textAlign: 'right' }}>
						  Doctor Package
						</BaseTypography>
					</Grid>
					<Grid item md={5} xs={12}>
					  <img src={doctorBanner} style={{ maxWidth: '50%' }} alt="Right" />
					</Grid>
				</Grid>
			</Grid>
		  </Grid>
		  <div className={clsx(commonClasses.container)} style={{ marginBottom: 40, padding: '0 20px' }}>
			<BaseCard>
				<Grid container spacing={10}>
				  <Grid item xs={12}>
					<Grid container spacing={4} className="grid-wrapper">
						<Grid item>
						  <img src={icon1} style={{ maxWidth: '100%' }} alt="Left" />
					    </Grid>
						<Grid item>
						  <BaseTypography variant="text" style={{ color: '#555555' }}>
							You have spent years building your medical expertise – studying, training, practicing, and contributing to patient outcomes. You have built credibility among peers and patients alike. But beyond the clinic or hospital, your voice remains largely unheard.
						  </BaseTypography>
					    </Grid>
					</Grid>
					<Grid container spacing={4} className="grid-wrapper">
						<Grid item>
						  <img src={icon2} style={{ maxWidth: '100%' }} alt="Left" />
					    </Grid>
						<Grid item>
						  <BaseTypography variant="text" style={{ color: '#555555' }}>
							You know your insights can educate the public, correct misconceptions, and influence better health outcomes. But restrictions set by medical boards and professional codes prevent self-promotion or traditional advertising. So how do you raise your professional profile while staying compliant?
						  </BaseTypography>
					    </Grid>
					</Grid>
					<Grid container spacing={4} className="grid-wrapper">
						<Grid item>
						  <img src={icon3} style={{ maxWidth: '100%' }} alt="Left" />
					    </Grid>
						<Grid item>
						  <BaseTypography variant="text" style={{ color: '#555555' }}>
							Maybe you have been invited to speak at small events or appeared in a webinar – but these haven’t translated into consistent opportunities to be heard on a larger stage.
						  </BaseTypography>
					    </Grid>
					</Grid>
				  </Grid>
				</Grid>
				<Grid container style={{ textAlign: 'center', justifyContent: 'center'  }}>
					<BaseTypography variant="text" style={{ color: 'rgb(0, 144, 229)', fontSize: '25px', marginBottom: '20px ' }}>
						That’s where<br /><strong>ContactsBook.Asia’s Doctor package</strong><br />comes in.
					</BaseTypography>
				</Grid>
				<Grid className="blue-bg" container style={{ padding: '20px 40px', alignItems: 'center', background: 'rgb(0, 144, 229)', gap: '30px', flexWrap: 'nowrap', borderRadius: '12px' }}>
					<Grid item md={8} xs={12}>
					  <BaseTypography variant="text" style={{ color: '#FFFFFF', fontSize: '20px' }}>
						We provide a platform for credible, knowledgeable medical professionals to gain visibility through media interviews, public speaking, and digital presence — without breaching ethical codes. From crafting your media profile to introducing you to relevant journalists and podcasters, we position you as a trusted voice in healthcare conversations that matter.
					  </BaseTypography>
					</Grid>
					<Grid item md={4} xs={12}>
					  <img src={imgNew} style={{ maxWidth: '100%' }} alt="Right" />
					</Grid>
				</Grid>
				<Grid className="lblue-bg" container style={{ marginTop: '20px', padding: '20px 40px', alignItems: 'center', background: '#5cccf2', gap: '30px', flexWrap: 'nowrap', borderRadius: '12px' }}>
				  <Grid item md={4} xs={12} style={{ background: '#5cccf2'}}>
					  <img src={imgNew} style={{ maxWidth: '100%' }} alt="Right" />
				  </Grid>
				  <Grid item md={8} xs={12}>
					  <BaseTypography variant="text" style={{ fontSize: '20px', color: '#FFFFFF' }}>
						<strong>ContactsBook.Asia</strong> is a directory for journalists, podcasters, event managers and other content producers searching for expert interview guests and speakers.<br /><br /> We connect more than 1,800+ registered journalists, including Tier-1 media, trade- and niche publications, to around 2,800 experts.
					  </BaseTypography>
					</Grid>
				</Grid>
				<Typography
					style={{ fontSize: '30px', color: '#0090E5', fontWeight: 'bold', margin: '30px 0' }}
					align="center">
					We provide
				</Typography>
				<Grid container>
				  <Grid item xs={12}>
					<Grid className="provide-container">
						<Grid item md={6} xs={12} className="provide-wrapper">
							<Grid container>
								<Grid item md={4} xs={12}>
								  <img src={img1} alt="Left" />
								</Grid>
								<Grid item md={8} xs={12}>
								  <h3 style={{ fontSize: '18px', margin: '0 0 15px 0' }}>On-Camera Interviews</h3>
								  <ul style={{ marginTop: '20px' }}>
									<li>Video interviews, short-form video content.</li>
								  </ul>
								</Grid>
							</Grid>
						</Grid>
						<Grid item md={6} xs={12} className="provide-wrapper">
							<Grid container>
								<Grid item md={4} xs={12}>
								  <img src={img2} alt="Left" />
								</Grid>
								<Grid item md={8} xs={12}>
								  <h3 style={{ fontSize: '18px', margin: '0 0 15px 0' }}>Media Kits &amp; VIP Book Events</h3>
								  <ul style={{ marginTop: '20px' }}>
									<li>Introductions to healthcare MNCs and medical podcasters.</li>
								  </ul>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid className="provide-container">
						<Grid item md={6} xs={12} className="provide-wrapper">
							<Grid container>
								<Grid item md={4} xs={12}>
								  <img src={img3} alt="Left" />
								</Grid>
								<Grid item md={8} xs={12}>
								  <h3 style={{ fontSize: '18px', margin: '0 0 15px 0' }}>Speaking Engagements</h3>
								  <ul style={{ marginTop: '20px' }}>
									<li>Opportunities for speaking engagements and curated industry introductions.</li>
									<li>Customised autograph card (left).</li>
								  </ul>
								</Grid>
							</Grid>
						</Grid>
						<Grid item md={6} xs={12} className="provide-wrapper">
							<Grid container>
								<Grid item md={4} xs={12}>
								  <img src={img4} alt="Left" />
								</Grid>
								<Grid item md={8} xs={12}>
								  <h3 style={{ fontSize: '18px', margin: '0 0 15px 0' }}>Sizzle Reels &amp; Professional Visuals</h3>
								  <ul style={{ marginTop: '20px' }}>
									<li>Animated “sizzle reel” and professional branding visuals.</li>
									<li>Recording and editing of your public speaking engagements.</li>
								  </ul>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid className="provide-container">
						<Grid item md={6} xs={12} className="provide-wrapper">
							<Grid container>
								<Grid item md={4} xs={12}>
								  <img src={img5} alt="Left" />
								</Grid>
								<Grid item md={8} xs={12}>
								  <h3 style={{ fontSize: '18px', margin: '0 0 15px 0' }}>Journalist &amp; Publisher Promotion</h3>
								  <ul style={{ marginTop: '20px' }}>
									<li>Promotion to hundreds of journalists, publishers.</li>
									<li>LinkedIn profile update.</li>
									<li>Promotion of your content on the websites of 225+ premium business publications.</li>
								  </ul>
								</Grid>
							</Grid>
						</Grid>
						<Grid item md={6} xs={12} className="provide-wrapper">
							<Grid container>
								<Grid item md={4} xs={12}>
								  <img src={img7} alt="Left" />
								</Grid>
								<Grid item md={8} xs={12}>
								  <h3 style={{ fontSize: '18px', margin: '0 0 15px 0' }}>Guaranteed Worldwide Media Distribution</h3>
								  <ul style={{ marginTop: '20px' }}>
									<li>Coverage by up to 400+ Media Organisations</li>
									<li>Up to 1m Journalists (targeted based on specific interests)</li>
								  </ul>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				  </Grid>
				</Grid>
				<Box mt={2} style={{ marginTop: '0' }}>
					<Box mt={4} mb={2.5} style={{ marginTop: '0' }}>
					  <Typography
						style={{ fontSize: '30px', color: '#0090E5', fontWeight: 'bold', marginBottom: '30px' }}
						align="center">
						Our Services
					  </Typography>
					</Box>
					<ServiceTable />
				</Box>
				
			</BaseCard>
		  </div>
		  
		  <div className={clsx(commonClasses.container)} style={{ marginBottom: 40, padding: '0 20px' }}>
			<BaseCard>
			  <Box mt={2} style={{ marginTop: '0' }}>
					<Box mt={4} mb={2.5} style={{ margin: '0' }}>
					  <Typography
						style={{ fontSize: '25px', color: '#0090E5', fontWeight: 'bold' }}
						align="center">
						Get much more than just posting on LinkedIn, for much less than engaging a publicist.
					  </Typography>
					</Box>
			  </Box>
		  </BaseCard>
		  </div>
		  <div className={clsx(classes.root, commonClasses.container)} style={{ margin: '0 auto' }}>
			<BaseCard>
			  <ExpertFormContainer />
			</BaseCard>
		  </div>
		  
		  <div className={clsx(classes.videoContainer)}>
			<iframe src="https://player.vimeo.com/video/876985187?h=8f771421c5&color=CE2828" title="test" width="100%" height="416" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen />
		  </div>
		  
		  <div style={{ textAlign: 'center' }}>
			<BaseTypography variant="text" style={{ color: 'rgb(0, 144, 229)', fontSize: '25px', margin: '20px', display: 'block' }}>
				<strong>Contact us to learn more about each of these services</strong>
			</BaseTypography>
			<ul className="contact-details">
				<li><img src={email} style={{ maxWidth: '40px' }} alt="Left" /><a rel="noreferrer noopener" target="_blank" href="mailto:service@contactsbook.asia">service@contactsbook.asia</a></li>
				<li><img src={phone} style={{ maxWidth: '40px' }} alt="Left" /><a rel="noreferrer noopener" target="_blank" href="tel:6562232249">(65) 6223 22 49 (Singapore)</a> | <a href="tel:60340650228">(603) 4065 0228 (Malaysia)</a></li>
			</ul>
			<ul className="social-share">
				<li><a rel="noreferrer noopener" target="_blank" href="https://linkedin.com/company/contactsbook-asia"><img src={LinkedIn} width="30" height="30" alt="Left" /></a></li>
				<li><a rel="noreferrer noopener" target="_blank" href="https://facebook.com/contactsbook.media"><img src={Facebook} width="30" height="30" alt="Left" /></a></li>
				<li><a rel="noreferrer noopener" target="_blank" href="https://x.com/contactsbook_a"><img src={twitter} width="30" height="30" alt="Left" /></a></li>
				<li><a rel="noreferrer noopener" target="_blank" href="https://youtube.com/@ContactsBookAsia"><img src={youtube}  width="30" height="30" alt="Left" /></a></li>
				<li><a rel="noreferrer noopener" target="_blank" href="https://instagram.com/contactsbook.asia"><img src={insta} width="30" height="30" alt="Left" /></a></li>
			</ul>
		</div>
		</div>
    )
}